var atlas = require('@ethereum-navigator/atlas');

function lookup(networkId) {
  var chainId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (typeof networkId === 'number') {
    networkId = '0x' + networkId.toString(16);
  }

  var networks = atlas.filter(function (network) {
    return network.networkId.toLowerCase() === networkId.toLowerCase();
  });

  if (chainId) {
    if (typeof chainId === 'number') {
      chainId = '0x' + chainId.toString(16);
    }

    var network = networks.find(function (network) {
      return network.chainId && network.chainId.toLowerCase() === chainId.toLowerCase();
    });

    if (network) {
      return network;
    }
  }

  return networks[0];
}

module.exports = lookup;